export const en = {
  'customer-fee-will-be-charged': 'A fee of %{fee} will be included.',
  'dynamic-currency-notice': 'Payment will be made in %{currency}: %{original} → %{converted}.',
  'dynamic-currency-notice-with-fee': 'Payment will be made in %{currency}: %{original} → %{converted}. (total: %{total})',
  'payment-method-unavailable': 'This payment method is currently unavailable.',
  'verification-failed': 'Verification failed.',
  'close': 'Close',
};

export const ja: typeof en = {
  'customer-fee-will-be-charged': '%{fee}の手数料が追加されます。',
  'dynamic-currency-notice': '支払いは%{currency}で決済されます: %{original} → %{converted}。',
  'dynamic-currency-notice-with-fee': '支払いは%{currency}で決済されます: %{original} → %{converted}。(合計%{total})',
  'payment-method-unavailable': 'この支払い方法は現在ご利用いただけません。',
  'verification-failed': '認証に失敗しました。',
  'close': '閉じる',
};
